import { QueryError, QueryRow } from './types'
import { QueryResultsTable } from './QueryResultsTable'
import { useTar } from '@/modules/i18n'

interface ResultsDisplayProps {
  queryResults?: QueryRow[];
  queryError?: QueryError;
}

const processQueryError = (queryError: QueryError): QueryError => {
  const [, errorMessage] = /^error: (.*)$/.exec(queryError.error) || []
  return {
    error: errorMessage ? `SQL Error: ${errorMessage}` : queryError.error,
    hint: queryError.hint
  }
}

export const QueryResults = ({
  queryResults,
  queryError,
}: ResultsDisplayProps) => {
  const processedQueryError = queryError ? processQueryError(queryError) : null
  return (
    <div className="h-full min-w-0" data-tour-id="query-results">
      {processedQueryError ? (
        <div className="p-4">
          <div className="bg-error/10 border border-error/20 rounded-sm p-4 min-h-[100px] flex items-center">
            <div className="text-error text-sm font-mono whitespace-pre-wrap">
              {processedQueryError.error}
              {processedQueryError.hint && <div className="text-xs text-muted-foreground">{processedQueryError.hint}</div>}
            </div>
          </div>
        </div>
      ) : (
        <QueryResultsTable queryResults={queryResults || []} />
      )}
    </div>
  )
}